package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.*
import com.essntl.features.itinerary.ui.rememberClientPurchaseEnabled
import com.essntl.features.itinerary.ui.rememberSupplierPurchaseEnabled
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.rememberFind
import core.config.FeatureConfig
import kotlinx.datetime.LocalDate

@Composable
fun ColumnScope.ItineraryServiceActions(
    state: EditItineraryState,
    onNavigation: (EditItineraryNavigation) -> Unit,
    itinerary: ItineraryModel,
    selectedItineraryServiceList: List<ItineraryServiceModel>,
    clients: List<ClientModel>,
    isConcierge: Boolean,
) {
    var isDropDownExpanded by remember { mutableStateOf(false) }

    var messagePopupType by remember { mutableStateOf(MessageSendType.SUPPLIER_PO) }

    val primaryClient =
        if (isConcierge) {
            val itineraryServicesClients =
                selectedItineraryServiceList.mapNotNull { state.rememberPrimaryClient(it.itineraryId) }
            if (itineraryServicesClients.isEmpty())
                null
            else {
                val client = itineraryServicesClients.first()
                if (itineraryServicesClients.all { it.id == client.id })
                    client else null
            }
        } else
            rememberFind(
                clients,
                itinerary.proposal?.primaryClient?.id,
            ) { client -> client.id }

    val isSupplierPurchaseEnabled = rememberSupplierPurchaseEnabled(selectedItineraryServiceList)

    val isClientPurchaseEnabled = rememberClientPurchaseEnabled(selectedItineraryServiceList, primaryClient)

    Row(
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Box {
            EsSmallOutlineIconButton(
                iconRes = EsIcons.ContactIcon,
                onClick = {
                    isDropDownExpanded = true
                },
            )

            EsDropDownMenu(
                expanded = isDropDownExpanded,
                onDismissRequest = { isDropDownExpanded = false },
                modifier = Modifier.width(187.dp),
            ) {
                if (FeatureConfig.hasWhatsapp)
                    EsDropdownMenuItem(
                        text = "Contact the client",
                        onClick = {
                            messagePopupType = MessageSendType.CLIENT
                            isDropDownExpanded = false

                            onNavigation(
                                EditItineraryNavigation.SendMessage(
                                    itineraryServices = selectedItineraryServiceList.sortedBy {
                                        LocalDate.parse(it.startDate)
                                    },
                                    type = messagePopupType,
                                ),
                            )
                        },
                        enabled = isClientPurchaseEnabled,
                        modifier = Modifier.height(40.dp),
                    )

                EsDropdownMenuItem(
                    text = "Contact the supplier",
                    onClick = {
                        messagePopupType = MessageSendType.SUPPLIER_PO
                        isDropDownExpanded = false

                        onNavigation(
                            EditItineraryNavigation.SendMessage(
                                itineraryServices = selectedItineraryServiceList.sortedBy {
                                    LocalDate.parse(it.startDate)
                                },
                                type = messagePopupType,
                            ),
                        )
                    },
                    enabled = isSupplierPurchaseEnabled,
                    modifier = Modifier.height(40.dp),
                )
            }
        }
    }
}